import React from 'react'

import { useSigEventsList } from '../hooks'

import Header from '../../common/components/Header'
import SigEventsListItem from './SigEventsListItem'

import styles from './SigEventsList.module.css'

const SigEventsList = () => {
  const [{ eventIds, isLoading }] = useSigEventsList()

  return (
    <div>
      <Header>
        {eventIds.length} Events{' '}
        {isLoading && <i className="fa fa-spinner fa-spin"></i>}
      </Header>
      <ul className={styles.list}>
        {eventIds.map((eventId, i) => (
          <SigEventsListItem eventId={eventId} key={i} />
        ))}
      </ul>
    </div>
  )
}

export default SigEventsList
